import React from 'react';
import SalesActionStatContainer from '../../containers/salesActionStat/SalesActionStatContainer';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';

const SalesActionStatPage = () => {
  return (
    <>
      <BreadcrumbsContainer title="영업활동관리/영업활동현황" icon="partner" />
      <SalesActionStatContainer />
    </>
  );
};

export default SalesActionStatPage;
